import { gql } from "@apollo/client"

export const DELETE_USER = gql`
  mutation($storeId: String!, $userId: String!) {
    deleteUser(restaurantId: $storeId, userId: $userId)
  }
`
